'use client';

import { Trans, t } from '@lingui/macro';
import { RocketLaunch } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { Button } from '@prismo-io/design-system';
import Image from 'next/image';
import Link from 'next/link';
import type { FC } from 'react';
type Props = {
  order: number;
  name: string | undefined;
  image?: string | undefined;
  redirectTo: string | undefined;
};
export const CustomCard: FC<Props> = (props: Props) => {
  const {
    name,
    redirectTo,
    order,
    image
  } = props;
  if (!name || !redirectTo) {
    return null;
  }
  return <Stack component="article" bgcolor="background.paper"
  // bgcolor="background.primary"
  borderRadius="3rem" p={2} zIndex={10} minWidth={{
    none: '100%',
    sm: '45%',
    lg: '31%'
  }} sx={{
    boxShadow: '2px 2px 7px 0px rgba(0,0,0,0.3)',
    flex: '1 1 0%',
    order: order
  }} direction="column" alignItems="center" spacing={2} data-sentry-element="Stack" data-sentry-component="CustomCard" data-sentry-source-file="index.tsx">
      {image && <Box component="div" position="relative" width="10.5rem" height="10.5rem">
          <Image src={image} alt="" style={{
        objectFit: 'contain',
        objectPosition: 'center'
      }} fill />
        </Box>}
      {!image && <Box component="div" position="relative" width="10.5rem" height="10.5rem">
          <RocketLaunch sx={{
        width: '100%',
        height: '100%'
      }} color="primary" />
        </Box>}
      <Box component="div" width="fit-content" marginX="auto" bgcolor="background.primary" borderRadius={1_000_000} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Typography color="primary.main" textAlign="center" paddingY={1} paddingX={2} variant="h4" fontWeight="bold" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          {name}
        </Typography>
      </Box>
      <Box component="div" data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Link href={redirectTo} passHref legacyBehavior target="_blank" data-sentry-element="Link" data-sentry-source-file="index.tsx">
          <Button variant="text" color="inherit" data-sentry-element="Button" data-sentry-source-file="index.tsx">
            <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">Accédez à {name}</Trans>
          </Button>
        </Link>
      </Box>
    </Stack>;
};